"use client";

import { useCurrentTheme } from "@/providers/ThemeProvider";
import { Toaster as Sonner, ToasterProps } from "sonner";

const Toaster = ({ ...props }: ToasterProps) => {
  const theme = useCurrentTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
          zIndex: 9999,
        } as React.CSSProperties
      }
      toastOptions={{
        style: {
          userSelect: "text",
          cursor: "text",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
